import Brand from "../../Classes/Brand";
import { brandViewerSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    currentBrand: new Brand(),
    addModal: false,
    editModal: false
}

export default function brandViewerSlice(state = initialState, action) {
    switch (action.type) {
        case brandViewerSliceDispatch.setCurrentQuestion: {
            return {
                ...state,
                currentBrand: action.payload
            }
        }
        case brandViewerSliceDispatch.setAddModal: {
            return {
                ...state,
                addModal: action.payload
            }
        }
        case brandViewerSliceDispatch.setEditModal: {
            return {
                ...state,
                editModal: action.payload
            }
        }
        default:
            return state
    }
}
